<template>

  <div id="branches">
    <div class="top-buttons">
      <button class="btn btn-primary" v-show="!showDeleted" @click="showDeleted = true">{{$t('branches.show_deleted')}}</button>
      <button class="btn btn-primary" v-show="showDeleted" @click="showDeleted = false">{{$t('branches.show_non_deleted')}}</button>
    </div>
    <Datatable
      entity="branch"
      ref="datatable"
      :onRowClick="onRowClick"
      :globalActions="[{text: 'branches.new', method: onBranchCreate}]"
      :parameters="{deleted: showDeleted}"
      :rowActions="[
        {text: 'datatable.edit', method: onRowEdit},
        {text: 'datatable.disable', method: onRowDisable, condition: r => r.active},
        {text: 'datatable.enable', method: onRowEnable, condition: r => !r.active},
        {text: 'datatable.delete', method: onRowDelete}
      ]"
    />

    <Modal
      name="confirmation"
      :title="$t('branches.confirmation')"
      dismissable
      :actions="[{name: $t('back'), action: 'close'}, {name: confirmationActionName, action: confirmationAction, primary: true}]">
      <p v-html="confirmationHtml"></p>
      <input type="text" class="w-100" v-model="toDeleteId" v-if="confirmationModel === 'delete'">
      <input type="text" class="w-100" v-model="toEnableId" v-if="confirmationModel === 'enable'">
      <input type="text" class="w-100" v-model="toDisableId" v-if="confirmationModel === 'disable'">
    </Modal>

    <Modal
      name="error"
      :title="$t('error.title')"
      :actions="[{name: $t('back'), action: 'close'}]">
      {{ $t(errorKey) }}
    </Modal>

  </div>

</template>

<script>

  import Datatable from "@/components/Datatable.vue";
  import { mapActions } from 'vuex';
  import {Core} from "@/core/Core";

  export default {

    name: 'branches',

    components: {Datatable},

    data() {
      return {
        actionRow: {},
        errorKey: "",
        toDeleteId: "",
        toEnableId: "",
        toDisableId: "",
        confirmationActionName: "",
        confirmationAction: "",
        confirmationHtml: "",
        confirmationModel: "",
        showDeleted: false,
      }
    },

    mounted() {
      if (!this.$store.getters.loggedUserHasSuperAdmin) {
        this.$router.replace("/companies?branch=" + this.$store.state.loggedUser.branch);
        return;
      }
      this.$store.state.pageTitleTranslationKey = "branches.title";
      this.$store.state.pageIcon = "/icon/branches.svg";
    },

    methods: {

      ...mapActions(["saveBranch"]),

      onBranchCreate() {
        this.$router.push("/branch/new");
      },

      onRowClick(row) {
        this.$router.push("/companies?branch=" + row.id);
      },

      onRowEdit(row) {
        this.$router.push("/branch/edit?branch=" + row.id);
      },

      onRowDelete(row) {
        this.actionRow = row;
        this.confirmationActionName = this.$t('datatable.delete');
        this.confirmationAction = this.deleteBranch;
        this.confirmationModel = "delete";
        this.confirmationHtml = this.$t('branches.delete_p1') + this.actionRow.name + this.$t('branches.delete_p2');
        this.$modal.show("confirmation");
      },

      async deleteBranch() {
        if (this.toDeleteId.toLowerCase() !== this.actionRow.name.toLowerCase()) {
          this.errorKey = "branches.error.delete_no_match";
          this.$modal.show("error");
          return;
        }
        try {
          this.$store.commit("showSpinner", true);
          await Core.request("DELETE", `/api/branches/${this.actionRow.id}`)
          this.$store.commit("showSpinner", false);
          this.$modal.show("confirmation", false);
          this.$refs.datatable.query();
          this.toDeleteId = "";
        } catch (e) {
          this.$store.commit("showSpinner", false);
          this.errorKey = "error.no_server";
          this.$modal.show("error");
        }
      },

      onRowDisable(row) {
        this.actionRow = row;
        this.confirmationActionName = this.$t('datatable.disable');
        this.confirmationAction = this.disableBranch;
        this.confirmationModel = "disable";
        this.confirmationHtml = this.$t('branches.disable_p1') +  this.actionRow.name + this.$t('branches.disable_p2');
        this.$modal.show("confirmation");
      },

      async disableBranch() {
        if (this.toDisableId.toLowerCase() !== this.actionRow.name.toLowerCase()) {
          this.errorKey = "branches.error.disable_no_match";
          this.$modal.show("error");
          return;
        }
        this.$store.commit("showSpinner", true);
        let response = await this.saveBranch({branchId: this.actionRow.id, data: {active: false}});
        this.$store.commit("showSpinner", false);
        if (response) {
          this.$modal.show("confirmation", false);
          this.$refs.datatable.query();
          this.toDisableId = "";
        } else {
          this.errorKey = "error.no_server";
          this.$modal.show("error");
        }
      },

      onRowEnable(row) {
        this.actionRow = row;
        this.confirmationActionName = this.$t('datatable.enable');
        this.confirmationAction = this.enableBranch;
        this.confirmationModel = "enable";
        this.confirmationHtml = this.$t('branches.enable_p1') +  this.actionRow.name + this.$t('branches.enable_p2');
        this.$modal.show("confirmation");
      },

      async enableBranch() {
        if (this.toEnableId.toLowerCase() !== this.actionRow.name.toLowerCase()) {
          this.errorKey = "branches.error.enable_no_match";
          this.$modal.show("error");
          return;
        }
        this.$store.commit("showSpinner", true);
        let response = await this.saveBranch({branchId: this.actionRow.id, data: {active: true, deleted: false}});
        this.$store.commit("showSpinner", false);
        if (response) {
          this.$modal.show("confirmation", false);
          this.$refs.datatable.query();
          this.toDisableId = "";
        } else {
          this.errorKey = "error.no_server";
          this.$modal.show("error");
        }
      }
    }
  };

</script>


<style lang="scss" scoped>
  .datatable {
    height: 100%;
  }
  .top-buttons {
    margin-bottom: 10px;
    text-align: right;
  }
</style>